import React from 'react'
import _ from 'lodash'
import HeredityProbabilityAnswerRow from '../../components/HeredityProbabilityAnswerRow'
import StudentQualityList from '../../components/StudentQualityList'
import SolutionRow from '../../components/SolutionRow'
import '../../assets/css/pages/track_progress/heredity-probability-submissions.css'

const HeredityProbabilitySubmissions = props => {
  const { description, geneKey, parentGenes, submissions } = props

  return(
    <div className='heredity-probability-submissions'>
      <div className='task'>
        <div className='header-item'>
          <span>TASK: </span>
          <span>{description}</span>
        </div>
        <div className='header-item'>
          <span>Gene Key: </span>
          <span>{geneKey}</span>
        </div>
        <div className='header-item'>
          <span>Parent Genes: </span>
          <span>{parentGenes[0]}, {parentGenes[1]}</span>
        </div>
      </div>
      <div className='solutions-wrapper'>
        {_.map(submissions, sub =>
          <div key={JSON.stringify(sub)} className='solution-wrapper'>
            <SolutionRow type={sub.isCorrect ? 'correct' : 'incorrect'}>
              {_.map(sub.answers, answer => <HeredityProbabilityAnswerRow key={JSON.stringify(answer)} {...answer}/>)}
            </SolutionRow>
            <div className='student-list-wrapper'>
              <StudentQualityList students={sub.students}/>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default HeredityProbabilitySubmissions
